




















































import { Component, Mixins, Watch } from "vue-property-decorator"
import QuestionMixins from "@/mixins/QuestionMixins"
import { mapState } from "vuex"
import BookingReportInfo from "./Report/BookingReportInfo.vue"
import BookingReportCandidateInfo from "./Report/BookingReportCandidateInfo.vue"
import BookingReportBodyMaps from "./Report/BookingReportBodyMaps.vue"
import BookingReportRiskProfileItems from "./Report/BookingReportRiskProfileItems.vue"
import BookingReportQuestions from "./Report/BookingReportQuestions.vue"
import BookingReportCandidateProfileQuestions from "./Report/BookingReportCandidateProfileQuestions.vue"
import BookingReportHeader from "./Report/partials/BookingReportHeader.vue"
import BookingReportDoctorAssessorComments from "./Report/BookingReportDoctorAssessorComments.vue"
import BookingReportDefinition from "./Report/BookingReportDefinition.vue"

@Component({
  components: {
    "component-candidate-response": BookingReportQuestions,
    "component-candidate-profile": BookingReportCandidateProfileQuestions,
    "component-information": BookingReportInfo,
    "component-candidate-information": BookingReportCandidateInfo,
    "component-body-maps": BookingReportBodyMaps,
    "component-risk-profiles": BookingReportRiskProfileItems,
    "component-doctor-assessor-comments": BookingReportDoctorAssessorComments,
    "component-definition": BookingReportDefinition,
    BookingReportHeader
  },
  computed: {
    ...mapState("QuestionnaireAnswer", {
      report: "report"
    }),
    ...mapState("Booking", {
      booking: "booking"
    }),
    ...mapState("BookingCandidate", {
      bookingCandidate: "bookingCandidate"
    })
  }
})
export default class BookingCandidateReport extends Mixins(QuestionMixins) {
  booking!: Model
  bookingCandidate!: Model

  isMounted = false
  onboarding = 0
  windowsLength = 3

  isApiFetch = {
    isApiFetchBookingCandidateFinished: false,
    isApiFetchQuestionnaireAnswerFinished: false
  }

  async beforeMount() {
    await this.$store
      .dispatch(
        "BookingCandidate/fetch",
        this.$route.params.bookingCandidateOid
      )
      .then(() => {
        this.isApiFetch["isApiFetchBookingCandidateFinished"] = true
      })
    await this.$store
      .dispatch(
        "QuestionnaireAnswer/fetchResult",
        this.$route.params.questionnaireAnswerOid
      )
      .then(() => {
        this.isApiFetch["isApiFetchQuestionnaireAnswerFinished"] = true
      })
  }

  @Watch("isApiFetch", { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false
        }
      }
      if (isFinished) {
        this.isMounted = true
      }
    }
  }

  next() {
    this.onboarding =
      this.onboarding + 1 === this.windowsLength ? 0 : this.onboarding + 1
  }

  prev() {
    this.onboarding =
      this.onboarding - 1 < 0 ? this.windowsLength - 1 : this.onboarding - 1
  }
}
